import React from "react";
import { Drawer, List } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "components/Header";
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Search from "components/Search";
import Profile from "./components/Profile";

import parseJwt from "utils/jwt";
import { getWithExpiry } from "utils/storage";

// context
import { useLayoutState } from "context/LayoutContext";

function DesktopNav({ location, items }) {
  const claims = parseJwt(getWithExpiry("access"));
  const { seller_id } = claims;

  const classes = useStyles();
  const { isSidebarOpened } = useLayoutState();

  return (
    <Drawer
      variant={"permanent"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <Header />
      <div className={classes.toolbar} />
      {seller_id === 1 ? <Search isSidebarOpened={isSidebarOpened} /> : null}

      <List className={classes.sidebarList}>
        {items
          .filter((item) => item.desktop)
          .map((item) => (
            <SidebarLink
              key={item.id}
              seller_id={seller_id}
              isCollapseOpened={items.length === 1}
              location={location}
              isSidebarOpened={isSidebarOpened}
              label={item.label}
              icon={item.icon}
              link={item.link}
              children={
                item.children
                  ? item.children.filter((child) => child.desktop)
                  : []
              }
            />
          ))}
      </List>
      <Profile />
    </Drawer>
  );
}

export default withRouter(DesktopNav);
